<template>
    <page :tabs="tabs" class="staylio-settings-page">
        <router-view @busy="handleBusy"></router-view>
    </page>
</template>

<script>
    import { mapGetters } from 'vuex';
    import page from '../generic/page/page.vue';

    export default {
        components: {
            page,
        },
        name: 'StaylioApp',
        data() {
            return {
                busy: false,
            };
        },
        computed: {
            ...mapGetters('header', ['userCurrencySymbol']),

            tabs() {
                const tabs = [];
                tabs.push({
                    title: 'Staylio Settings',
                    active: this.$route.path === `/app/staylio-app/settings/`,
                    route: `/app/staylio-app/settings/`,
                });
                return tabs;
            },
        },
        mounted() {
            if (this.$route.path === '/app/staylio-app/') {
                this.$router.push('/app/staylio-app/settings/');
            }
        },
        methods: {
            handleBusy(busy) {
                this.busy = busy;
            },
        },
    };
</script>

<style lang="scss" scoped>
    .staylio-settings-page {
        padding: 0 15px 60px 15px;
        :deep(ul.nav) {
            margin-left: 0 !important;
            margin-bottom: 0 !important;
            .nav-link.active {
                background-color: #f7f7f7 !important;
                margin-bottom: 0 !important;
                border-color: #dee2e6 #dee2e6 transparent;
            }
        }
        :deep(.lx-page-container) {
            padding: 10px 0 30px 0;
            background-color: #f7f7f7;
            border-bottom: 1px solid #ddd;
            border-left: 1px solid #ddd;
            border-radius: 0 5px 5px 5px;
            border-right: 1px solid #ddd;
            @media (max-width: 768px) {
                padding: 0 0 120px 0;
            }
            .input-wrapper .vue-tel-input .form-phone-number-input-label {
                background-color: #fff !important;
            }
        }
        .form-tip {
            display: flex;
            align-items: center;
            height: 40px;
            margin-bottom: 1rem;
        }
        .proceed-setup-toolbar {
            width: 100%;

            position: fixed;
            bottom: 10px;
            left: 15px;
        }
    }
</style>
